import top from "@/pages/global/components/top-bar/top-bar.vue";
import navigation from "@/pages/global/components/nav-bar/nav-bar.vue";
import bottom from "@/pages/global/components/bottom-bar/bottom-bar.vue";

import { mapState } from "vuex";

export default {
    beforeMount () {
        this.$store.dispatch('adminAppSettings/fetchInitialData');
    },
    components: {
        top,
        navigation,
        bottom
    },
    computed: {
        ...mapState('adminAppSettings', {
            settingsLoaded: state => state.settingsLoaded,
        }),
        maintenanceMode: {
            get() {
                return this.$store.state.adminAppSettings.maintenanceMode;
            },
            set(value) {
                this.$store.commit("adminAppSettings/setMaintenanceMode", value);
            }
        },
        androidAppVersionMandatory: {
            get() {
                return this.$store.state.adminAppSettings.androidAppVersionMandatory;
            },
            set(value) {
                this.$store.commit("adminAppSettings/setAndroidAppVersionMandatory", value);
            }
        },
        iosAppVersionMandatory: {
            get() {
                return this.$store.state.adminAppSettings.iosAppVersionMandatory;
            },
            set(value) {
                this.$store.commit("adminAppSettings/setIosAppVersionMandatory", value);
            }
        },
        androidAppVersion: {
            get() {
                return this.$store.state.adminAppSettings.androidAppVersion;
            },
            set(value) {
                this.$store.commit("adminAppSettings/setAndroidAppVersion", value);
            }
        },
        iosAppVersion: {
            get() {
                return this.$store.state.adminAppSettings.iosAppVersion;
            },
            set(value) {
                this.$store.commit("adminAppSettings/setIosAppVersion", value);
            }
        }
    },
    methods: {
        updateMaintenanceMode(evt) {
            evt.preventDefault();
            this.$store.dispatch('adminAppSettings/updateMaintenanceMode');
        },
        updateAndroidSettings(evt) {
            evt.preventDefault();
            this.$store.dispatch('adminAppSettings/updateAndroidSettings');
        },
        updateIosSettings(evt) {
            evt.preventDefault();
            this.$store.dispatch('adminAppSettings/updateIosSettings');
        },
    }
};


// WEBPACK FOOTER //
// ./src/pages/administration/admin/app-settings/master/app-settings.js